/* @jsx h */
import { defineComponent, h } from "vue";

export interface AppSubpageHeaderProps {
  icon?: string;
  title: string;
  description?: string;
  actions?: any;
  meta?: any;
  center?: any;
}

export const AppSubpageHeader = defineComponent({
  name: "AppSubpageHeader",
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
  },
  setup(props, { slots }) {
    return () => (
      <div class="border-b sticky top-0 bg-base-200/60">
        <div class="px-4 xl:px-6 py-5 relative">
          <div class="flex justify-between items-center gap-4">
            {/* Left: custom start content, or Title & Description */}
            <div class="flex-shrink-0">
              {slots.start
                ? slots.start()
                : [
                    <h1
                      key="title"
                      class=" font-bold text-accent tracking-tight flex items-center gap-3"
                    >
                      {props.icon && (
                        <div class="hidden lg:flex text-2xl p-0 w-12 h-12  justify-center items-center bg-primary/10 rounded-lg">
                          <span class="material-symbols-outlined text-2xl text-primary">
                            {props.icon}
                          </span>
                        </div>
                      )}
                      <span class="text-xl lg:text-2xl">{props.title}</span>
                    </h1>,
                    (props.description || slots.description) && (
                      <p
                        key="desc"
                        class={`hidden lg-block text-md mt-0 ${props.icon ? "ml-16" : ""}`}
                      >
                        {slots.description
                          ? slots.description()
                          : props.description}
                      </p>
                    ),
                  ]}
            </div>

            {/* Center: Optional centered content (like date selector) */}
            {slots.center && (
              <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                {slots.center()}
              </div>
            )}

            {/* Right: Meta info and actions */}
            <div class="flex items-center gap-3 flex-shrink-0">
              {slots.controls && slots.controls()}
              {slots.meta && (
                <div class="inline-flex items-center gap-2 px-3 py-1.5 bg-base-200 rounded-lg text-sm text-base-content/70">
                  {slots.meta()}
                </div>
              )}
              {slots.actions && slots.actions()}
            </div>
          </div>
        </div>

        {/* Optional bottom section for tabs or additional controls */}
        {slots.bottom && <div class="px-4 xl:px-6">{slots.bottom()}</div>}
      </div>
    );
  },
});
